import React from 'react';

export default class LoaderOverlay extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log('LoaderOverlay', this.props);

		return (
			<div className="LoaderOverlay">
				<div
					className="loadingOverlay"
					style={
						this.props.overlay_color ? (
							{ backgroundColor: this.props.overlay_color }
						) : (
							{}
						)
					}
				>
					<div className="spinner" />
				</div>
				<div
					style={{
						position: 'fixed',
						top: 0,
						left: 0,
						width: '100%',
						height: '100%',
						zIndex: 100
					}}
				/>
			</div>
		);
	}
}
